import { css } from '@emotion/react'
import { Button, Cell, Grid, HFlow, VFlow } from 'bold-ui'
import {
  CidadaoAtendimentoSelectField,
  Form,
  FormRenderProps,
  PecFormApi,
  SubmitButton,
  TextAreaField,
} from 'components/form'
import { TipoServicoSelectField } from 'components/form/field/select/TipoServicoSelectField'
import { DEMANDA_REPRIMIDA_PATH, GARANTIA_ACESSO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import { useFlags } from 'config/useFlagsContext'
import { useAdicionarGarantiaAcessoCeoMutation } from 'graphql/hooks.generated'
import { metaPath } from 'util/metaPath'

import { convertGarantiaAcessoFormModelToInput } from '../convert-garantiaAcesso'
import { GarantiaAcessoFormModel } from '../model-garantiaAcesso'
import { garantiaAcessoValidator } from '../validator-garantiaAcesso'

const path = metaPath<GarantiaAcessoFormModel>()

interface GarantiaAcessoCeoFormViewProps {
  initialValues: GarantiaAcessoFormModel
  onRegistrosConflitantes(values: GarantiaAcessoFormModel): Promise<boolean>
  onResetFormFields: (formApi: PecFormApi) => void
  onSaveSuccess: () => void
}

export default function GarantiaAcessoCeoFormView(props: GarantiaAcessoCeoFormViewProps) {
  const { initialValues, onRegistrosConflitantes, onResetFormFields, onSaveSuccess } = props

  const { PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()
  const [salvar] = useAdicionarGarantiaAcessoCeoMutation()

  const save = (values: GarantiaAcessoFormModel, formApi: PecFormApi<GarantiaAcessoFormModel>) =>
    salvar({ variables: { input: convertGarantiaAcessoFormModelToInput(values) } }).then(() => {
      onSaveSuccess()
      onResetFormFields(formApi)
    })

  const handleSubmit = (values: GarantiaAcessoFormModel, formApi: PecFormApi<GarantiaAcessoFormModel>) => {
    return onRegistrosConflitantes(values).then((confirmed) => confirmed && save(values, formApi))
  }

  const renderForm = (formProps: FormRenderProps<GarantiaAcessoFormModel>) => {
    return (
      <Grid>
        <Cell size={5}>
          <VFlow>
            <CidadaoAtendimentoSelectField
              name={path.cidadao}
              label='Cidadão'
              title='Cidadão'
              ativo
              required
              placeholder='Pesquise por Nome completo, CPF, CNS ou data de nascimento'
              obito={false}
              addCidadaoCallbackUrl={
                PILOTO_INTEGRACAO_REGULACAO_ENABLED ? DEMANDA_REPRIMIDA_PATH : GARANTIA_ACESSO_PATH
              }
              verificarPresenteNaListaAtendimento={false}
            />
            <TextAreaField
              name={path.motivo}
              label='Motivo'
              title='Motivo'
              maxLength={200}
              required
              style={css`
                height: 5rem;
                resize: none;
              `}
            />
          </VFlow>
        </Cell>

        <Cell size={5}>
          <VFlow>
            <TipoServicoSelectField name={path.tipoServico} label='Tipo de serviço' title='Tipo de serviço' required />
          </VFlow>
        </Cell>

        <Cell alignSelf='flex-end' size={12}>
          <HFlow justifyContent='flex-end'>
            <Button size='medium' onClick={() => onResetFormFields(formProps.form)}>
              Limpar campos
            </Button>
            <SubmitButton size='medium' handleSubmit={formProps.handleSubmit}>
              Adicionar
            </SubmitButton>
          </HFlow>
        </Cell>
      </Grid>
    )
  }

  return (
    <Form<GarantiaAcessoFormModel>
      render={renderForm}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validate={garantiaAcessoValidator(true)}
    />
  )
}
